<div>
  <form #df="ngForm" novalidate>
    <div class="table-responsive table-striped mt-3"
      style="max-height: none !important; overflow-y: visible !important; overflow-x: auto !important;">
      <table mat-table [dataSource]="dataSource" class="w-100">
        <ng-container matColumnDef="Id">
          <th mat-header-cell *matHeaderCellDef style="width: 3.125rem;">#</th>
          <td mat-cell *matCellDef="let element; let i = index" class="grid-cell" style="width: 3.125rem;">
            {{ i + 1 }}
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="scoreType">
          <th mat-header-cell *matHeaderCellDef style="text-align: left !important">
            Score Type
          </th>
          <td mat-cell *matCellDef="let element" class="grid-cell">{{ element.ScoreType }}</td>
          <td mat-footer-cell *matFooterCellDef class="text-center"></td>
        </ng-container>

        <ng-container matColumnDef="values">
          <th mat-header-cell *matHeaderCellDef style="min-width: 12rem;">Values</th>
          <td mat-cell *matCellDef="let element" class="grid-cell" style="min-width: 12rem;">
            <ng-container>
              <!-- Edit mode dropdown for static factors -->
              <select
                *ngIf="(!element.IsDyanamic || element.IsDyanamic == 'false' || element.IsDyanamic == 0) && isEditing"
                class="form-control input-text-css" [(ngModel)]="element.ScoreValue" [name]="'scoreVal_' + element.Id"
                (change)="onDropdownChange(element)">
                <option [ngValue]="null" disabled>Select Values</option>
                <option *ngFor="let option of element.values" [ngValue]="option">
                  {{ option.value }}
                </option>
              </select>

              <!-- View mode for static factors -->
              <span
                *ngIf="(!element.IsDyanamic || element.IsDyanamic == 'false' || element.IsDyanamic == 0) && !isEditing">
                {{ element.scoreViewName || element.ScoreValue?.value || element.ScoreValue }}
              </span>

              <!-- Dynamic factors -->
              <span *ngIf="element.IsDyanamic && element.IsDyanamic != 'false' && element.IsDyanamic != 0">
                {{ element.ScoreValue }}
              </span>
            </ng-container>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="Score">
          <th mat-header-cell *matHeaderCellDef style="text-align: left !important; width: 6rem;">
            Score
          </th>
          <td mat-cell *matCellDef="let element" class="grid-cell" style="width: 6rem;">
            {{ element.FinalScore }}
          </td>
          <td mat-footer-cell *matFooterCellDef class="text-right">
            <strong>{{ totaltypewise("FinalScore") }}</strong>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
      </table>
    </div>

    <!-- <div class="row m-0 col-md-12 formborder mt-3 p-2 align-items-center" style="clear: both;">
      <div class="col-md-9 p-1">
        <span class="required-lable"> Remarks </span>
        <textarea [disabled]="!isEditing"
                  required
                  #refRemarks="ngModel"
                  maxlength="500"
                  [(ngModel)]="Remarks"
                  (ngModelChange)="onRemarksChange()"
                  placeholder="Remarks"
                  name="Remarks"
                  id="Remarks"
                  class="form-control input-text-css"
                  rows="2"></textarea>
      </div>

      <div class="col-md-3 text-right">
        <button type="button"
                class="mt-3 btn font-size-12 button-btn"
                (click)="toggleEditMode()"
                *ngIf="
          PageData.currentTab == 1 &&
          Status != 'C' &&
          (Status == 'R' ? (Revert_IsEdit == 1 ? true : false) : true)
        "
                [disabled]="isEditing && !canSave()">
          {{ isEditing ? "Save" : "Edit" }}
        </button>
      </div>
    </div> -->
  </form>
</div>

<!-- <div class="row col-md-12 m-0 mt-3 mb-3 justify-content-end" style="clear: both;">
  <button type="button" (click)="nextPageRedirectFunc()" class="btn font-size-12 button-btn">
    Next <i class="fa fa-arrow-right"></i>
  </button>
</div> -->